/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Digest_BodyInputs */

const en_platform_digest_body = /** @type {(inputs: Platform_Digest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each morning you get an email with the whole day: who, when and what for. The day before, clients get a reminder and confirm whether they'll come.`)
};

const pl_platform_digest_body = /** @type {(inputs: Platform_Digest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rano dostajesz e-mail z całym dniem: kto, o której i na co. Podopieczni dzień wcześniej dostają przypomnienie i potwierdzają, czy będą.`)
};

/**
* | output |
* | --- |
* | "Each morning you get an email with the whole day: who, when and what for. The day before, clients get a reminder and confirm whether they'll come." |
*
* @param {Platform_Digest_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_digest_body = /** @type {((inputs?: Platform_Digest_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Digest_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_digest_body(inputs)
	return en_platform_digest_body(inputs)
});